import React from 'react'

const BuildingSummary = () => {
    return (
        <div>
            <div className='box'>
                <div className="dashboard p-3">
                    <h6 className="text-center text-light"><b>Summary Dashboard</b></h6>
                    <div className="sumry p-1 mt-4">
                        <li><span>Buildings</span> <span>ES001</span></li>
                        <li><span>Total Numbers of Floors:</span> <span>3</span></li>
                        <li><span>Number of Occupants</span> <span>20</span></li>
                        <li><span>Total Numbers of Assets</span> <span>30</span></li>
                        <li><span>Total Energy Used:</span> <span>940 kwh</span></li>
                        <li><span>Avg . Energy per Occupants</span> <span>630 kwh</span></li>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BuildingSummary;